export const OTPServiced = ({ BeURL, email, otp, onClose, purpose, setVerifyed, setSignUP }) => {

    fetch(`${BeURL}/verify-otp`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, otp: otp.join(""), purpose })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                if (purpose !== "forgot-password") {
                    alert(data.message)
                    setSignUP(true)
                    onClose(false)
                }
                else {
                    if (setVerifyed)
                        setVerifyed(true)
                }
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.error('Error in OTP verify:', err);
            alert('Trouble in connecting to the Server! Please try again later.')
        })
}



